import type { CommitmentTypes } from '../model/enums'
import type { AcknowledgmentCommitmentItem } from '../model/types'

export const isAcknowledgmentGroupComplete = (
  items: AcknowledgmentCommitmentItem[],
  commitmentType: CommitmentTypes
) => {
  const mandatory = items.filter(
    (item) => item.CommitmentType === commitmentType && !item.IsOptional
  )
  return (
    mandatory.length > 0 &&
    mandatory.every((item) => Boolean(item.SignerEmail?.trim()) && item.IsAcknowledged === 1)
  )
}
